import React from 'react';

import ContentConnectorApollo from './Connector/Apollo/Fetch/ContentConnectorApollo';
import DietFaqContainer from './DietFaqContainer';

class DietFaqPage extends React.Component {
    static propTypes = {};

    render() {
        return (
            <ContentConnectorApollo identifier="faq:dietitian">
                {({ ...contentData }) => <DietFaqContainer {...contentData} />}
            </ContentConnectorApollo>
        );
    }
}

export default DietFaqPage;
